/**
 * Labstep
 *
 * @module components/Protocol/Action/Run
 * @desc Run a protocol
 */

import ExperimentWorkflowActionCreate from 'labstep-web/components/ExperimentWorkflow/Action/Create';
import type { ActionComponentProps } from 'labstep-web/core/Action/Component/types';
import type React from 'react';
import type { IProtocolActionRunProps } from './types';

export const ProtocolActionRun: React.FC<IProtocolActionRunProps> = ({
  protocol,
}) => {
  if (protocol.is_draft) {
    return null;
  }
  let actionComponentProps: ActionComponentProps = {
    type: 'button',
    icon: 'play',
    showIcon: true,
    elementProps: {
      size: 'small',
      basic: true,
      primary: true,
    },
    text: 'Run',
  };
  if (!protocol.is_last_version) {
    actionComponentProps = {
      ...actionComponentProps,
      modalConfirmationProps: {
        header: 'Superseded Protocol',
        message:
          'There is a more recent version of this protocol. Are you sure you want to run this version?',
        positive: false,
        confirmButtonContent: 'Run Superseded Protocol',
      },
    };
  }
  return (
    <ExperimentWorkflowActionCreate
      actionComponentProps={actionComponentProps}
      protocol={protocol}
    />
  );
};
